import { useState } from "react";
import Tabs from "../../../../components/tabs/tabs";
import * as CSS from "./chat-module.styles";
import type { ChatStatuses } from "./components/chat-module.types";
import CommentFeed from "./components/comment-feed/comment-feed";

const ChatModule = () => {
	const [activeTab, setActiveTab] = useState<ChatStatuses>("unread");

	return (
		<CSS.ChatModule>
			<Tabs
				activeTab={activeTab}
				onChange={(id) => setActiveTab(id as ChatStatuses)}
				items={[
					{
						id: "unread",
						label: "Unread",
					},
					{
						id: "shared",
						label: "Shared",
					},
					{
						id: "archived",
						label: "Archived",
					},
				]}
			/>
			<CommentFeed status={activeTab} />
		</CSS.ChatModule>
	);
};

export default ChatModule;
